import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { useTheme } from '../hooks/useTheme.js';
import { sanitizeHtml } from './sanitizeHtml.js';

var RichTextView = function (_a) {
    var html = _a.html, props = __rest(_a, ["html"]);
    var handleStyleProps = useTheme().handleStyleProps;
    var forwardProps = handleStyleProps(props, {
        themeKey: "richTextView",
    });
    return (jsx("div", __assign({}, forwardProps, { dangerouslySetInnerHTML: { __html: html ? sanitizeHtml(html) : "" } })));
};

export { RichTextView };
//# sourceMappingURL=RichTextView.js.map
